import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import PatternListModal, { NoPatternListModal } from './PatternListModal';
import { useEffect, useState } from 'react';

// import SearchResultList from '../../Search/list/SearchResultList';
import FilterBox from './FilterBox';
import PatternService from '../../../service/Pattern';

import {
  ListDataProps,
  MyPatternListProps,
} from '../../../interface/aiAnalyze/aiRecommend/type';
import Footer from '../../components/footer/Footer';
import { PriceList } from '../../../interface/aiAnalyze/aiRecommend/data';
import PageTop from '../../components/pageTop/PageTop';
import List from '../../components/list/List';
import AddInterestItemModal from '../../components/modal/AddInterestItem';
import Menu from '../../components/menu/Menu';
import UserService from '../../../service/User';
import { useModal } from '../../../context/ModalContext';
import Description_Box from '../../components/description/Description';
import AlgorithmSection from '../../main/components/AlgorithmSection';

const AiRecommendation = () => {
  const location = useLocation();
  const [recommendAlgorithmList, setRecommendAlgorithmList] = useState<
    MyPatternListProps[]
  >([]);

  const [selectedAlgorithmKey, setSelectedAlgorithmKey] = useState<
    string | null
  >(location.state?.selectedAlgorithmKey ?? null);
  const [showLikeModal, setShowLikeModal] = useState<boolean>(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [mode, setMode] = useState<string>('add');
  const [selectedIdx, setSelectedIdx] = useState<number>(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeItem, setActiveItem] = useState<number | null>(null);
  const [myPatternList, setMyPatternList] = useState<MyPatternListProps[]>([]);
  const [selectedItem2, setSelectedItem2] = useState({
    iidx: 0,
    group: '',
    group_idx: 0,
    level: 0,
    memo: '',
  });
  const [selectedItem, setSelectedItem] = useState<MyPatternListProps>({
    analysis_type: '',
    appraisal_point: '',
    bid_cnt: '',
    court: null,
    create_time: '',
    ctp: '',
    elapsed_years: '',
    emd: '',
    end_date: '',
    hidden_value: '',
    hug: '',
    investment_rate: '',
    item_category: '',
    lien: '',
    login_type: '',
    margin: '',
    market_prc: '',
    opposing_power: '',
    p_idx: 0,
    pnu: '',
    profit: '',
    resale: '',
    sale_days: '',
    sig: '',
    start_date: '',
    statutory_superficies: '',
    title: '',
    tomb_base_right: '',
    type: '',
    user_id: '',
    violation_building: '',
    wage_bond: '',
    zoning: '',
    grade: null,
  });

  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(20);
  const [total, setTotal] = useState<number>(0);
  const [listData, setListData] = useState<ListDataProps[]>([]);
  const [sort, setSort] = useState({
    value: 'DA',
    label: '매각기일 빠른순',
  });
  const [loading, setLoading] = useState(false);
  const [pnuCode, setPnuCode] = useState('');
  const [itemStatus, setItemStatus] = useState('');
  const [price, setPrice] = useState('');
  const [filters, setFilters] = useState({
    type: 'a',
    regionOrCourt: 'r',
    region: [],
    court: '',
    itemStatus: [],
    multiItemStatus: [],
    appraisalPrice: { min: '', max: '' },
    minPrice: { min: '', max: '' },
    saleDate: { start: '', end: '' },
    approvalDate: { start: '', end: '' },
    buildingArea: { min: '', max: '' },
    landArea: { min: '', max: '' },
    bidStatus: '',
    progressStatus: '진행',
    useArea: [],
    multiUseArea: [],
    specialConditionViewOption: 'o',
    specialItemCondition: [],
    multiSpecialItemCondition: [],
    holdingCompany: [],
    multiHoldingCompany: [],
  });
  const getList = async () => {
    try {
      if (await UserService.userGrade()) {
        const res = await PatternService.patternList('B', 20, 0);
        setMyPatternList(res.data.list);
      } else {
        modalDispatch({ type: 'MC1' });
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getList();
  }, []);

  const ChangePriceValue = (price: string) => {
    const newValue = PriceList.find((item) => item.label === price)?.value;
    return newValue ?? '';
  };
  const { modalDispatch } = useModal();

  const fetchRecommendPatterns = async () => {
    try {
      const res = await PatternService.patternListRecommend(limit, offset);
      setRecommendAlgorithmList(res.data.list);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchRecommendPatterns();
  }, []);

  const getRecommendationList = async (offset: number, sort: string) => {
    try {
      let targetId: number = 0;

      if (selectedAlgorithmKey?.startsWith('추천')) {
        const index =
          parseInt(selectedAlgorithmKey.replace('추천', ''), 10) - 1;
        const pattern = recommendAlgorithmList[index];
        if (pattern) {
          targetId = pattern.p_idx;
        }
      } else if (selectedItem.p_idx > 0) {
        targetId = selectedItem.p_idx;
      }

      if (targetId === 0) return;

      const res = await PatternService.list(
        targetId,
        sort,
        limit,
        offset,
        pnuCode === '' ? 'A' : pnuCode,
        itemStatus === '' ? 'A' : itemStatus,
        price === '' ? 'A' : ChangePriceValue(price),
      );

      setListData(res.data.list);
      setTotal(res.data.totalNumber);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const targetId =
      selectedAlgorithmKey === null ? selectedItem.p_idx : selectedAlgorithmKey;

    if (targetId && targetId !== 0) {
      getRecommendationList(0, sort.value);
    }
  }, [
    selectedAlgorithmKey,
    selectedItem,
    pnuCode,
    itemStatus,
    price,
    sort,
    offset,
  ]);

  useEffect(() => {
    if (selectedItem.p_idx > 0) {
      getRecommendationList(offset, sort.value);
    }
  }, [offset]);

  useEffect(() => {
    getRecommendationList(0, sort.value);
  }, [
    selectedAlgorithmKey,
    selectedItem,
    pnuCode,
    itemStatus,
    price,
    sort,
    recommendAlgorithmList,
  ]);

  return (
    <Container>
      <PageTop text="AI 기반 실시간 경매 추천" setOpenMenu={setOpenMenu} />
      <Content>
        <Inner>
          <Description_Box
            only="24px 16px 0"
            desc1="내 전략에 맞춘 실전 경매 물건, AI가 즉시 매칭해드립니다."
            desc2="저장한 나만의 공식으로 현재 진행 중인 전국 경매 물건을 AI가 실시간 매칭해 추천합니다."
          />
          <PatternBox>
            <AlgorithmSection
              page="airecommendation"
              selectedKey={selectedAlgorithmKey}
              onSelect={setSelectedAlgorithmKey}
            />
            {selectedAlgorithmKey === null && selectedItem.p_idx > 0 ? (
              <LoadMyPatternButton
                onClick={() => {
                  setIsModalOpen(true);
                  setSelectedAlgorithmKey(null);
                }}
                active={true}
              >
                <span>{`${selectedItem.title}  적용`} </span>
                <ChangePatternButton
                  onClick={() => {
                    setIsModalOpen(true);
                  }}
                >
                  알고리즘 변경
                </ChangePatternButton>
              </LoadMyPatternButton>
            ) : (
              <LoadMyPatternButton
                onClick={() => {
                  setIsModalOpen(true);
                  setSelectedAlgorithmKey(null);
                }}
                active={false}
              >
                <img src="/assets/images/plus/plus-blue.svg" alt="" />
                <span>나만의 AI 알고리즘 불러오기</span>
              </LoadMyPatternButton>
            )}
          </PatternBox>
          <ListBox>
            <FilterBox
              setPnuCode={setPnuCode}
              itemStatus={itemStatus}
              setItemStatus={setItemStatus}
              price={price}
              setPrice={setPrice}
            />
            {/* {listData && (
              <SearchResultList
                limit={limit}
                setOffset={setOffset}
                data={listData}
                totalCount={total}
                setSort={setSort}
                offset={offset}
                sort={sort}
                loading={loading}
              />
            )} */}

            <List
              data={listData}
              totalCount={total}
              sort={sort}
              setSort={setSort}
              setOffset={setOffset}
              filters={filters}
              limit={limit}
              loading={loading}
              page="search"
              setSelectedIdx={setSelectedIdx}
              setShowLikeModal={setShowLikeModal}
              setMode={setMode}
              setSelectedItem={setSelectedItem2}
              activeItem={activeItem}
              setActiveItem={setActiveItem}
              getList={getList}
            />
            {showLikeModal && (
              <AddInterestItemModal
                setShowLikeModal={setShowLikeModal}
                selectedIdx={selectedIdx}
                mode={mode}
                selectedItem={selectedItem2}
                getList={getList}
                offset={offset}
                sort={sort}
                filters={filters}
                setActiveItem={setActiveItem}
              />
            )}
          </ListBox>
        </Inner>
      </Content>
      <Footer />
      {isModalOpen && myPatternList.length > 0 && (
        <PatternListModal
          setIsModalOpen={setIsModalOpen}
          data={myPatternList}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />
      )}
      {isModalOpen && myPatternList.length === 0 && (
        <NoPatternListModal setIsModalOpen={setIsModalOpen} />
      )}
      {openMenu && <Menu page="myAlgorithm" setOpenMenu={setOpenMenu} />}
    </Container>
  );
};

export default AiRecommendation;

const Container = styled.div`
  width: 100%;
  font-family: Spoqa Han Sans Neo;
  position: relative;
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const Inner = styled.div`
  display: flex;
  flex-direction: column;
`;

const PatternBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 24px 16px 16px;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const LoadMyPatternButton = styled.div<{ active: boolean }>`
  min-width: 212px;
  height: 105px;
  flex: 0 0 auto;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border-radius: 12px;
  border: ${(props) =>
    props.active ? '2px solid #008aff' : '1px dashed #e1e2e4'};
  font-size: 14px;
  font-weight: 500;
  color: #222;
  cursor: pointer;
  background-color: ${(props) => (props.active ? '#EAF2FE' : '#ffffff')};
`;

const ChangePatternButton = styled.span`
  border-radius: 8px;
  background: #008aff;
  color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  padding: 9px 16px;
`;
const ListBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
